module.exports = __webpack_public_path__ + "img/multilingue.4e8373ca.svg";